import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

import { Component } from "react"

class SweepstakesUserForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fields: {
                name: props.name || "",
                phone: props.phone || "",
                address: props.address || "",
                email: props.email || "",
                marketingConsent: false,
                termsAgree: false
            },
            errors: {},
            showModal: false,
        }
    }

    componentDidUpdate(prevProps) {
        const updatedFields = {};
        let hasChanges = false;

        Object.keys(this.state.fields).forEach((key) => {
            if (this.props[key] !== prevProps[key]) {
                updatedFields[key] = this.props[key] || "";
                hasChanges = true;
            }
        });

        if (hasChanges) {
            this.setState((prevState) => ({
                fields: { ...prevState.fields, ...updatedFields }
            }));
        }
    }

    setValue = (event) => {
        let fields = this.state.fields;
        fields[event.target.name] = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        this.setState({ fields });
        this.props.setValue(event);
    }

    validate = (event) => {
        const phonePattern = /\d{10}/;
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        let errors = {};
        if (!this.state.fields["name"]) {
          errors["name"] = "Required";
        }
        if (!this.state.fields["phone"]) {
            errors["phone"] = "Required";
        }
        if (this.state.fields["phone"] && !phonePattern.test(this.state.fields["phone"])) {
            errors["phone"] = "Invalid phone number";
        }
        if (!this.state.fields["address"]) {
            errors["address"] = "Required";
        }
        if (!this.state.fields["city"]) {
            errors["city"] = "Required";
        }
        if (!this.state.fields["state"]) {
            errors["state"] = "Required";
        }
        if (!this.state.fields["zip"]) {
            errors["zip"] = "Required";
        }
        if (!this.state.fields["email"]) {
            errors["email"] = "Required";
        }
        if (!this.state.fields['termsAgree']) {
            errors["termsAgree"] = "Required";
        }
        if (this.state.fields["email"] && !emailPattern.test(this.state.fields["email"])) {
            errors["email"] = "Invalid email address";
        }
        this.setState({ errors: errors });
        if (Object.keys(errors).length === 0) {
            this.props.submit(event);
        }
    }

    showModal = (event) => {
        this.setState({ "showModal": true});
    }

    render() {
        return (
            <div className={`${!this.props.show && 'Hide'} Text-left Top-margin`}>
                <div className="Top-margin"></div>
                <div className="Input">
                    <Row>
                        <Col>First and Last Name*:</Col>
                        <Col><input name="name" onChange={this.setValue} value={this.state.fields["name"]}/><span style={{ color: "red" }}>  {this.state.errors["name"]}</span></Col>
                    </Row>
                </div>
                <div className="Input">
                    <Row>
                        <Col>Email Address*:</Col>
                        <Col><input name="email" onChange={this.setValue} value={this.state.fields["email"]}/><span style={{ color: "red" }}>  {this.state.errors["email"]}</span></Col>
                    </Row>
                </div>
                <div className="Input">
                    <Row>
                        <Col>Phone*: (numeric characters only)</Col>
                        <Col><input type="tel" pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}" name="phone" onChange={this.setValue} value={this.state.fields["phone"]}/><span style={{ color: "red" }}>  {this.state.errors["phone"]}</span></Col>
                    </Row>
                </div>
                <div className="Input">
                    <Row>
                        <Col>Street Address*:</Col>
                        <Col><input name="address" onChange={this.setValue} value={this.state.fields["address"]}/><span style={{ color: "red" }}>  {this.state.errors["address"]}</span></Col>
                    </Row>
                </div>
                <div className="Input">
                    <Row>
                        <Col>City*:</Col>
                        <Col><input name="city" onChange={this.setValue} value={this.state.fields["city"]}/><span style={{ color: "red" }}>  {this.state.errors["city"]}</span></Col>
                    </Row>
                </div>
                <div className="Input">
                    <Row>
                        <Col>State*:</Col>
                        <Col><input name="state" onChange={this.setValue} value={this.state.fields["state"]}/><span style={{ color: "red" }}>  {this.state.errors["state"]}</span></Col>
                    </Row>
                </div>
                <div className="Input">
                    <Row>
                        <Col>Zip*:</Col>
                        <Col><input name="zip" onChange={this.setValue} value={this.state.fields["zip"]}/><span style={{ color: "red" }}>  {this.state.errors["zip"]}</span></Col>
                    </Row>
                </div>
                <div className="Input">
                    <Row>
                        <Col><p><input name="marketingConsent" type="checkbox" onChange={this.setValue} checked={this.state.fields["marketingConsent"]}/>&nbsp;&nbsp;By checking the box, you consent to receive email at the email address provided, as well as phone calls and text messages (including prerecorded, autodialed and/or AI-generated calls and texts) at the phone number you provided from American Home Shield regarding our products and services. You understand that your consent is not a condition of entry.</p></Col>
                    </Row>
                </div>
                <div className="Input">
                    <Row>
                        <Col><p><input name="termsAgree" type="checkbox" onChange={this.setValue} checked={this.state.fields["termsAgree"]}/>&nbsp;&nbsp;By checking the box you acknowledge you have read and agree to the <a href={this.props.rulesUrl || "#"} target="_blank">Official Rules</a>.</p>
                        <div style={{ color: "red" }}>  {this.state.errors["termsAgree"]}</div></Col>
                    </Row>
                </div>
                <div>
                    <i>*Required Fields</i>
                </div>
                <Button size="lg" variant="primary" onClick={this.validate}>Next</Button>
            </div>
        )
    }
}

export default SweepstakesUserForm;